import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamAlertListRoute: InvariantJiraRoute = {
	name: 'eoc-team-alerts',
	path: '/jira/ops/teams/:teamId/alerts',
	exact: true,
};
